// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__329O6","lightMode":"Logo_lightMode__R2xFz","darkMode":"Logo_darkMode__nugn8"};